module.exports = __webpack_public_path__ + "static/media/medium.09c838e1.svg";